import React from 'react';

import { bemCssModules, correctingTrailingNumbers } from '@cryptoboyio/mercuryo-lab/utils';
import { useTranslation } from 'react-i18next';

import { getIntlDate, getTestId } from '@utils';
import { useTotalDigits } from '@utils/hooks';
import { LanguageCodeTypes } from '@utils/types';

import { useStore } from '@modules';

import { useCustomContext } from '../context';

import style from './RefEarn.scss';

const cn = bemCssModules(style, 'RefEarn');
const ti = getTestId('RefEarn');

export const RefEarn: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const [{ transactions, global }] = useStore();
  const { languageCode, currency } = useCustomContext();
  const { getTotalDigits, getDisplayDigits } = useTotalDigits();

  const { lang } = global;
  const { data } = transactions.referral;
  const totalFriendsValue = data?.count || 0;
  const totalSum = data?.sum.total || '0';
  const sumExpected = data?.sum.expected || '0';

  const totalDigits = getTotalDigits(currency);
  const displayDigits = getDisplayDigits(currency);

  const getPluralKey = (value: number, language?: LanguageCodeTypes) =>
    new Intl.PluralRules(language).select(value);

  const key = getPluralKey(totalFriendsValue, lang);

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <div className={cn('wrapper-info')}>
        <div className={cn('total')}>
          <div className={cn('title', ['h4'])}>{t('referral.transactions')}</div>
          <span className={cn('value')}>
            {t(`referral.friends_value.${key}`, { totalFriendsValue })}
          </span>
        </div>
        <div className={cn('total')}>
          <div className={cn('title')}>{t('referral.total_reward', { currency })}</div>
          <span className={cn('value')}>
            {correctingTrailingNumbers(totalSum, displayDigits, totalDigits)}
          </span>
        </div>
      </div>
      <div className={cn('wrapper-rewards')}>
        <div>
          {t('referral.pending_reward', {
            currency,
            month: getIntlDate(String(new Date().getMonth() + 1), { month: 'long' }, languageCode),
          })}
        </div>
        <div className={cn('reward')}>
          {correctingTrailingNumbers(sumExpected, displayDigits, totalDigits)} {currency}
        </div>
      </div>
    </div>
  );
};

export default RefEarn;
